"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _consts = require("./../../consts.js");

var _OzRow = _interopRequireDefault(require("./../../OzRow/OzRow.js"));

var _OzCol = _interopRequireDefault(require("./../../OzCol/OzCol.js"));

var _OzCard = _interopRequireDefault(require("./../../OzCard/OzCard.js"));

var _OzButton = _interopRequireDefault(require("./../../OzButton/OzButton.js"));

var _OzTypo = _interopRequireDefault(require("./../../OzTypo/OzTypo.js"));

var _OzInput = _interopRequireDefault(require("./../../OzInput/OzInput.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Error = _styledComponents.default.div.withConfig({
  displayName: "FormSetName__Error",
  componentId: "sc-jwi6yn-0"
})(["\n  height: 30px;\n  color: ", ";\n"], _consts.BITTERSWEET);

var FormSetName = function FormSetName(_ref) {
  var onConfirm = _ref.onConfirm,
      error = _ref.error;

  var _useState = (0, _react.useState)(''),
      givenName = _useState[0],
      setGivenName = _useState[1];

  var _useState2 = (0, _react.useState)(''),
      familyName = _useState2[0],
      setFamilyName = _useState2[1];

  return __jsx(_OzCard.default, null, __jsx(_OzTypo.default, {
    variant: "h1c",
    color: _consts.CHETWODEBLUE
  }, "Set name"), __jsx(_react.default.Fragment, null, "Enter your names."), __jsx(_OzRow.default, null, __jsx(_OzCol.default, {
    widthmd: "6"
  }, __jsx(_OzInput.default, {
    label: "Given Name",
    name: "givenName",
    type: "text",
    width: "100%",
    value: givenName,
    onChange: function onChange(val) {
      return setGivenName(val);
    },
    required: true
  })), __jsx(_OzCol.default, {
    widthmd: "6"
  }, __jsx(_OzInput.default, {
    label: "Family Name",
    name: "familyName",
    type: "text",
    width: "100%",
    value: familyName,
    onChange: function onChange(val) {
      return setFamilyName(val);
    },
    required: true
  })), __jsx(_OzCol.default, {
    widthmd: "12"
  }, __jsx(_OzButton.default, {
    variant: "chetwodeblue",
    onClick: function onClick() {
      return onConfirm({
        action: "set-name",
        params: {
          givenName: givenName,
          familyName: familyName
        }
      });
    }
  }, "Save")), __jsx(_OzCol.default, {
    widthmd: "12"
  }, __jsx(Error, null, __jsx("br", null), error, __jsx("br", null)))));
};

var _default = FormSetName;
exports.default = _default;